import React, { useState } from 'react';
import Datetime from "react-datetime";
import moment, { Moment } from 'moment';
//import '../../styles/modules/datetimepicker.less';

interface TimePickerProps {
  onChange: (time: string) => void;
  initialValue?: string;
}

const TimePicker: React.FC<TimePickerProps> = ({ onChange, initialValue }) => {
  const handleTimeChange = (value: Moment | string) => {
    const formattedTime = moment(value).format("hh:mm A");
    onChange(formattedTime);
  };

  return (
    <div className="form-group">
      <Datetime
        input={false}
        dateFormat={false}
        timeFormat="hh:mm A"
        onChange={handleTimeChange}
        className="rdtCounters"
        initialValue={moment(initialValue, "hh:mm A")}
      />
    </div>
  );
}

export default TimePicker;